
      var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAlert = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 121,
  height: 120,
  viewBox: "0 0 121 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M60.5 21.833c21.043 0 38.167 17.124 38.167 38.167 0 21.043-17.124 38.167-38.167 38.167-21.043 0-38.167-17.124-38.167-38.167 0-21.043 17.124-38.167 38.167-38.167Z",
  stroke: "#13051A",
  strokeWidth: 3.667
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M60.5 75a3.75 3.75 0 1 1 0 7.5 3.75 3.75 0 0 1 0-7.5Zm.219-37.663a4.048 4.048 0 0 1 3.817 4.34l-1.959 26.445a2.083 2.083 0 0 1-4.155 0l-1.958-26.444A4.047 4.047 0 0 1 60.5 37.33l.219.006Z",
  fill: "url(#alert_34350ec6f6702bd1__a)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "alert_34350ec6f6702bd1__a",
  x1: 60.5,
  y1: 37.5,
  x2: 60.5,
  y2: 82.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.834,
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})))));

      const __svgRaw = "<svg width=\"121\" height=\"120\" viewBox=\"0 0 121 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M60.5 21.833C81.5431 21.833 98.667 38.9569 98.667 60C98.667 81.0431 81.5431 98.167 60.5 98.167C39.4569 98.167 22.333 81.0431 22.333 60C22.333 38.9569 39.4569 21.833 60.5 21.833Z\" stroke=\"#13051A\" stroke-width=\"3.66667\"/>\r\n<path d=\"M60.5 74.9998C62.5709 74.9998 64.2498 76.6789 64.25 78.7498C64.25 80.8208 62.5711 82.4997 60.5 82.4998C58.4289 82.4998 56.75 80.8208 56.75 78.7498C56.7502 76.6788 58.429 74.9998 60.5 74.9998ZM60.7188 37.3367C62.967 37.4561 64.7045 39.404 64.5361 41.6775L62.5771 68.1218C62.4964 69.2095 61.5907 70.0505 60.5 70.0505C59.4092 70.0505 58.5026 69.2096 58.4219 68.1218L56.4639 41.6775C56.29 39.3307 58.1468 37.3308 60.5 37.3308L60.7188 37.3367Z\" fill=\"url(#paint0_linear_8631_157490)\"/>\r\n<defs>\r\n<linearGradient id=\"paint0_linear_8631_157490\" x1=\"60.5\" y1=\"37.5001\" x2=\"60.5\" y2=\"82.4998\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.83414\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n<stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n</linearGradient>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/alert.34350ec6f6702bd16c6fc873bb71de58.svg"),
        {
          React: SvgAlert,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      